var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "hov group cursor-pointer",
      attrs: { id: _vm.item.id },
      on: {
        click: function($event) {
          _vm.go(_vm.item.id)
        }
      }
    },
    [
      _c("small", [_vm._v(_vm._s(_vm.index + 1))]),
      _vm._v(" "),
      _c("q-icon", { attrs: { name: _vm.$utils.icon(_vm.item.id) } }),
      _vm._v(" "),
      _c("unit-path", { attrs: { id: _vm.item.id, withoutLink: true } }),
      _vm._v(" "),
      _c("result-fields", {
        attrs: { item: _vm.item },
        on: {
          pass: function($event) {
            _vm.go(_vm.item.id, $event)
          }
        }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-ee6684fa", { render: render, staticRenderFns: staticRenderFns })
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-ee6684fa","hasScoped":true,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/result-item.vue
// module id = null
// module chunks = 